import { Spinner } from '@climate-x-org/ui-kit'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuthStatus } from '@/hooks/useAuthStatus'
import { Login } from '@/pages/Login'

const LoginRoute = (): JSX.Element => {
  const authStatus = useAuthStatus()

  if (authStatus === 'checking') {
    return (
      <div className='flex min-h-screen items-center justify-center'>
        <Spinner size='lg' />
      </div>
    )
  }

  if (authStatus === 'authenticated') {
    return <Navigate to='/organizations' />
  }

  return <Login />
}

export const Route = createFileRoute('/login')({
  component: LoginRoute,
})
